import { render, staticRenderFns } from "./shopComment.vue?vue&type=template&id=5e4a9df7&"
import script from "./shopComment.vue?vue&type=script&lang=ts&"
export * from "./shopComment.vue?vue&type=script&lang=ts&"
import style0 from "./shopComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports